import { GenericDropdown, Label, Block } from '@/forms-legacy'
import { useOptions } from './useOptions'
import { useOnChange } from './useOnChange'
import { useTexts } from './useTexts'

type RecurrenceEndDropdownProps = {
  testId?: string
  type: uui.domain.client.rm.RecurrenceEnd['endType']
}
export function RecurrenceEndDropdown(props: RecurrenceEndDropdownProps) {
  const { type, testId = 'RecurrenceEndDropdown' } = props
  const options = useOptions()
  const texts = useTexts()
  const onChange = useOnChange()

  return (
    <Block data-testid={testId}>
      <Label>{texts.label}</Label>
      <GenericDropdown
        name="recurrenceEndType"
        selectedIds={[type]}
        values={options}
        onChanged={onChange}
      />
    </Block>
  )
}
